import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import { Spinner } from 'react-bootstrap'
import { SearchInput } from '../../components/kyc/SearchInput'
import HistoryTable from '../../components/History/HistoryTable'
import '../../components/kyc/kycStyle.css'
import { downloadUserReport, getUserReports } from '../../api/user/user'

import { CSVLink } from 'react-csv'
import KycButton from '../../components/form/Button/Button'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { HISTORY_SUBHEADING } from '../../utils/Constants'

interface Report {
  reference: string
  name: string
  reportType: string
  requestedAt: string
  id: string
  reportTypeDescription: string
  reportTypeId: number
  reportIdNumber: string
  isActive: boolean
}

interface Props {
  setIsError: React.Dispatch<React.SetStateAction<boolean>>
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>
  setShow: React.Dispatch<React.SetStateAction<boolean>>
}

export const ReportHistory: React.FC<Props> = ({
  setIsError,
  setErrorMessage,
  setShow,
}) => {
  const [showProgress, setShowProgress] = useState(false)
  const [data, setData] = useState<Report[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const recordsPerPage = 5
  const [searchString, setSearchString] = useState('')
  const indexOfLastRecord = currentPage * recordsPerPage
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
  const [currentRecords, setCurrentRecords] = useState<Report[]>([])
  const [nPages, setNpages] = useState(0)
  const [runSearch, setRunSearch] = useState(false)
  const getUserReportsParams = {
    setShowProgress,
    setIsError,
    setErrorMessage,
    setData,
    setCurrentRecords,
    setNpages,
    recordsPerPage,
    indexOfFirstRecord,
    indexOfLastRecord,
  }

  const handleDownloadReport = (report: Report) => {
    const downloadUserReportParams = {
      report,
      setShowProgress,
      setIsError,
      setErrorMessage,
    }
    downloadUserReport(downloadUserReportParams)
  }
  const searchReports = () => {
    const filteredData = data.filter((report) => {
      return JSON.stringify(report)
        .toLowerCase()
        .includes(searchString.toLowerCase())
    })
    setCurrentRecords(filteredData)
  }

  useEffect(() => {
    if (data.length === 0) getUserReports(getUserReportsParams)
    searchReports()
  }, [runSearch, currentPage])

  const handleSearch = () => {
    searchReports()
  }

  const onSearchChange = (value: string) => {
    setSearchString(value)
  }

  return (
    <ScreenLayout headerText="History" subHeaderText={HISTORY_SUBHEADING}>
      {showProgress && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      <Form.Group style={{ marginBottom: '10px' }}>
        <SearchInput
          searchText={searchString}
          handleSearch={onSearchChange}
          placeHolder={'Search references'}
        />
        <FooterButtons handleSearch={handleSearch} setShow={setShow} />
      </Form.Group>
      <div
        style={{
          height: '400px',
          overflow: 'auto',
        }}
      >
        {currentRecords.length > 0 ? (
          <HistoryTable
            currentRecords={currentRecords}
            handleDownloadReport={(report) => handleDownloadReport(report)}
          />
        ) : showProgress ? (
          <p>Loading...</p>
        ) : (
          <p>No reports found.</p>
        )}
      </div>
      {/* {nPages > 1 && (
        <Pagination
          nPages={nPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          handlePageChange={handlePageChange}
        />
      )} */}
      <div className="download">
        <CSVLink
          style={{ color: '#fff', textDecoration: 'none' }}
          data={data}
          filename={'report.csv'}
        >
          Download Records in CSV Format
        </CSVLink>
      </div>
    </ScreenLayout>
  )
}
export default ReportHistory
